<!--修改数据的dialog-->
<template>
	<div ref="board" class="coordinate">
		<div class="form-wrap-title fixState" v-if="titleState">
			<div class="title">题号设置</div>
			<el-form ref="addTitleForm" :model="addTitleForm" label-width="80px" label-position="left" size="medal">
				<el-row>
					<el-col :span="24">
						<el-form-item label="题号设置">
							<el-input type="number" min="0" placeholder="请输入题号" v-model="addTitleForm.objTitle" ref="title"> </el-input>
						</el-form-item>
					</el-col>
					<el-col :span="11">
						<el-form-item label="横向坐标">
							<step :isFilterZero="false" :defaultVal="addTitleForm.x" :step="0.5" @stepVal="changeTitlePos($event, 'x')"></step>
						</el-form-item>
					</el-col>
					<el-col :span="11" :offset="2">
						<el-form-item label="纵向坐标">
							<step :isFilterZero="false" :defaultVal="addTitleForm.y" :step="0.5" @stepVal="changeTitlePos($event, 'y')"></step>
						</el-form-item>
					</el-col>
					<el-col :span="24" class="btn-evenly">
						<el-button type="primary" @click="setTitleConfirm">确定</el-button>
						<el-button @click="titleState = false">取消</el-button>
					</el-col>
				</el-row>
			</el-form>
		</div>
		<div class="form-wrap-rect fixState" :class="tabActive === 'examNo' || tabActive === 'choose' ? 'heightDia' : 'miniDia'" v-if="fixRectState">
			<div class="title">选项调整</div>
			<el-form ref="form" :model="rectForm" label-width="80px" label-position="left" size="medal">
				<el-row>
					<el-col :span="11">
						<el-form-item label="选项宽度">
							<step :defaultVal="rectForm.w" :step="0.5" @stepVal="changePpiVal($event, 'w')"></step>
						</el-form-item>
					</el-col>
					<el-col :span="11" :offset="2">
						<el-form-item label="选项高度">
							<step :defaultVal="rectForm.h" :step="0.5" @stepVal="changePpiVal($event, 'h')"></step>
						</el-form-item>
					</el-col>
					<el-col :span="11">
						<el-form-item label="横向坐标">
							<step :defaultVal="rectForm.x" :step="0.5" @stepVal="changePpiVal($event, 'x')"></step>
						</el-form-item>
					</el-col>
					<el-col :span="11" :offset="2">
						<el-form-item label="纵向坐标">
							<step :defaultVal="rectForm.y" :step="0.5" @stepVal="changePpiVal($event, 'y')"></step>
						</el-form-item>
					</el-col>
					<el-col :span="24" v-show="tabActive === 'examNo' || tabActive === 'choose'">
						<el-form-item label="选项设置">
							<el-select v-model="rectForm.v" placeholder="请输入选项设置" style="width: 100%">
								<el-option v-for="item in [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]" :key="item" :label="item" :value="item"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="24" class="btn-evenly">
						<el-button type="primary" @click="confirmEdit">确定</el-button>
						<el-button @click="fixRectState = false">取消</el-button>
					</el-col>
				</el-row>
			</el-form>
		</div>
		<!--考号 -->
		<div class="form-wrap-exam-title fixState" v-if="addRectState">
			<div class="title">新增选项</div>
			<el-row>
				<el-col :span="5">选项设置</el-col>
				<el-col :span="19">
					<el-input placeholder="请输入选项值" v-model="rectVal" ref="title"> </el-input>
				</el-col>
				<el-col :span="24" class="btn-end" style="margin-top: 20px">
					<el-button type="primary" @click="examNoAddRect">确定</el-button>
					<el-button @click="addRectState = false">取消</el-button>
				</el-col>
			</el-row>
		</div>
		<div class="fixState" style="width: 200px" v-if="rotateState">
			<div class="title">旋转区域</div>
			<el-row>
				<el-col :span="24" class="center">
					<el-button type="primary" @click="rotateDown" class="bg-green">竖直向下旋转</el-button>
				</el-col>
				<el-col :span="24" class="center marTop20">
					<el-button type="primary" class="bg-green" @click="rotateUp">竖直向上旋转</el-button>
				</el-col>
				<el-col :span="24" class="center marTop20">
					<el-button type="primary" class="color-yellow" @click="rotateRight">水平向右旋转</el-button>
				</el-col>
				<el-col :span="24" class="center marTop20 ">
					<el-button type="primary" class="color-yellow" @click="rotateLeft">水平向左旋转</el-button>
				</el-col>
				<el-col :span="24" class="btn-end marTop20">
					<el-button @click="quitRotate">取消</el-button>
					<el-button type="primary" @click="confirmRotate">确定</el-button>
				</el-col>
			</el-row>
		</div>
		<div class="fixState" v-show="handleSetObjVal.state">
			<div class="title">初始题号</div>
			<el-form ref="addTitleForm" label-width="100px" label-position="left" size="medal">
				<el-row>
					<el-col :span="24">
						<el-form-item label="初始题号设置">
							<el-select v-model="initObjVal" placeholder="请选择" style="width: 100%">
								<el-option v-for="item in totalResObjTopic" :key="item.smallTopic" :label="item.smallTopic" :value="item.smallTopic">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="24" class="btn-evenly">
						<el-button type="primary" @click="confirmHandleSetTit">确定</el-button>
						<el-button @click="quitHandleSetTit">取消</el-button>
					</el-col>
				</el-row>
			</el-form>
		</div>
	</div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { refreshBox } from '../utils/js/help'
import { setHandleCopyInit } from '../utils/js/recognise'
import { horizontalRotate, verticalRotate } from '../utils/js/rotate'
import dragMixin from '@/mixin/drag-mixin'
import { sortBy } from 'lodash/collection'
export default {
	name: 'temp-adjust-coordinate',
	components: {
		step: () => import('../utils/component/step')
	},
	mixins: [dragMixin],
	data() {
		return {
			//题号设置 dialog state
			titleState: false,
			//选项调整 dialog state
			fixRectState: false,
			// 新增选项 dialog state
			addRectState: false,
			//旋转区域  dialog state
			rotateState: false,
			//新增选项的值
			rectVal: '',
			//选项调整 的各个参数
			rectForm: {
				w: 1,
				h: 1,
				x: 1,
				y: 0,
				v: null
			},
			//新增题号的参数
			addTitleForm: {
				objTitle: '',
				x: 0,
				y: 0
			},
			// no use
			titleLeft: 0,
			// no use
			posLeft: 0,
			query: this.$route.query,
			//大框激活选项索引
			rectIndex: null,
			//ppi 索引
			ppiIndex: null,
			//所有框子数据
			rectInfo: {},
			//拖拽距离
			dragStartX: 0,
			dragStartY: 0,
			//旋转角度
			rotateDegree: 0,
			//缩放倍数
			scaleState: 1,
			//客观题情况下的
			rectItem: [],
			//no use
			focusTitletState: '',
			//当前旋转框子索引
			rotateIndex: null,
			//考号的数据
			formatExamNoObj: {},
			//客观题的数据
			formatObjectiveObj: {},
			//初始题号
			initObjVal: '',
			// 所有的客观题列表  标志位
			totalResObjTopic: []
		}
	},
	watch: {
		//旋转角度之后 派发
		tempRotateArea(val) {
			this.formatList(val)
		},
		// 修改标题
		tempFixRectTitle(val) {
			this.ppiIndex = val.ppiIndex
			this.rectForm = val.currentPpi
			this.rectIndex = val.rectIndex
			this.titleState = val.titleState
			this.fixRectState = val.rectState
			this.addTitleForm.x = val.currentPpi.x
			this.addTitleForm.y = val.currentPpi.y
			this.addTitleForm.objTitle = val.currentPpi.v
		},
		//客观题--->数据来自后端
		tempObjTopic(val) {
			let totalResObjTopic = []
			val.forEach(res => (totalResObjTopic = [...totalResObjTopic, ...res.val]))
			this.totalResObjTopic = totalResObjTopic
			// console.log(totalResObjTopic)
		}
	},
	computed: {
		...mapGetters('examination/configation', [
			'tempRotateArea',
			'tempRectExamNoInfo',
			'tempEditImgInfo',
			'tabActive',
			'typeLack',
			'tempObjTopic',
			'handleSetObjVal',
			'tempChooseList',
			'tempSelLikeSubOrObjVal',
			'tempRectObjective',
			'tempFixRectTitle'
			// 'tempExamObjAddRect'
		])
	},
	mounted() {
		this.titleLeft = document.documentElement.clientWidth / 2 - 250
		this.posLeft = document.documentElement.clientWidth / 2 - 350
		this.$nextTick(() => {
			this.$refs['board'].style.transform = `translateX(${this.dragStartX}px) translateY(${this.dragStartY}px)`
		})
	},
	methods: {
		...mapMutations('examination/configation', ['setTempRectExamNoInfo', 'setTempRectObjective', 'setTempFlushData', 'setHandleSetObjVal']),
		...mapActions('examination/databases', ['set', 'get']),
		force() {
			this.$forceUpdate()
		},
		// 确定 设置题号
		async setTitleConfirm() {
			let isCanFix = false
			if (this.tempObjTopic.length === 0) {
				this.$message.error('请选择题块')
				return false
			}
			let changedTopic = {}
			this.tempObjTopic.forEach(resp => {
				resp.val.forEach(res => {
					if (res.smallTopic + '' === this.addTitleForm.objTitle + '') {
						isCanFix = true
						changedTopic = res
					}
				})
			})
			if (isCanFix) {
				let rectDetail = this.tempRectObjective.val
				let appendInfo = JSON.parse(rectDetail[this.rectIndex].appendInfo)
				let remarks = JSON.parse(rectDetail[this.rectIndex].remarks)
				let originTitle = remarks.title
				if (typeof originTitle === 'string') originTitle = JSON.parse(originTitle)
				let box = JSON.parse(rectDetail[this.rectIndex].appendInfo).box
				let yHeight = this.rectForm.h * 0.8
				let fixBox = [],
					getFixBox = []
				box.forEach(res => {
					if (this.rectForm.y >= res.y - yHeight && res.y <= this.rectForm.y + yHeight && res.i === this.rectForm.v) {
						fixBox.push(res)
						res.canDel = true
					} else {
						getFixBox.push(res)
					}
				})
				let newCurTitle = Object.assign({}, this.rectForm, {
					n: changedTopic.pkId,
					m: changedTopic.bigTopic,
					v: changedTopic.smallTopic,
					x: +this.addTitleForm.x,
					y: +this.addTitleForm.y
				})
				originTitle[this.ppiIndex] = newCurTitle
				fixBox.forEach(res => {
					res.n = changedTopic.pkId
					res.m = changedTopic.bigTopic
				})
				let resultBox = [...getFixBox, ...fixBox]
				appendInfo.box = resultBox
				remarks.title = originTitle
				rectDetail[this.rectIndex].appendInfo = JSON.stringify(appendInfo)
				rectDetail[this.rectIndex].remarks = JSON.stringify(remarks)
				//----------------------------------------------------
				const params = {
					subjectId: this.query.subjectId,
					examId: this.query.examId,
					versionId: this.tempEditImgInfo.versionId,
					ppiId: rectDetail[this.rectIndex]['pkId'],
					ppiStr: JSON.stringify(rectDetail[this.rectIndex])
				}
				this.$post('Cv/refreshPpi', params).then(res => {
					if (res.code === 200) {
						this.$message.success('题号修改成功')
						this.setTempFlushData({ state: false })
						this.titleState = false
					}
				})
			} else {
				this.$message.success('请设置正确的题号')
			}
		},
		// 确定微调小框框
		confirmEdit() {
			let rectDetail = []
			if (this.tabActive === 'examNo') {
				rectDetail = this.tempRectExamNoInfo
			} else if (this.tabActive === 'objective') {
				rectDetail = this.tempRectObjective.val
			} else if (this.tabActive === 'choose') {
				rectDetail = this.tempChooseList
			} else if (this.tabActive === 'lack') {
				rectDetail = this.typeLack
			}
			let appendInfo = JSON.parse(rectDetail[this.rectIndex].appendInfo)
			let box = JSON.parse(rectDetail[this.rectIndex].appendInfo).box
			let resultCurrentPpi = {
				w: this.rectForm.w,
				h: this.rectForm.h,
				x: this.rectForm.x,
				y: this.rectForm.y,
				v: this.rectForm.v
			}
			if (this.tabActive === 'choose') {
				this.tempSelLikeSubOrObjVal.forEach(res => {
					res.items.forEach(resp => {
						if (resp.smallTopic === this.rectForm.v) {
							resultCurrentPpi.n = resp.pkId
						}
					})
				})
			}
			box[this.ppiIndex] = Object.assign({}, box[this.ppiIndex], resultCurrentPpi)
			appendInfo.box = box
			rectDetail[this.rectIndex].appendInfo = JSON.stringify(appendInfo)
			const params = {
				subjectId: this.query.subjectId,
				examId: this.query.examId,
				versionId: this.tempEditImgInfo.versionId,
				ppiId: rectDetail[this.rectIndex]['pkId'],
				ppiStr: JSON.stringify(rectDetail[this.rectIndex])
			}
			this.$post('Cv/refreshPpi', params).then(res => {
				if (res.code === 200) {
					this.$message({ type: 'success', message: '修改成功', duration: 3000 })
					this.setTempFlushData({ state: true })
					this.titleState = false
					this.fixRectState = false
				}
			})
		},
		// 微调小框框  change
		changePpiVal(val, type) {
			this.rectForm[type] = val
			let rectDetail = []
			if (this.tabActive === 'examNo') {
				rectDetail = this.tempRectExamNoInfo
			} else if (this.tabActive === 'objective') {
				rectDetail = this.tempRectObjective.val
			} else if (this.tabActive === 'choose') {
				rectDetail = this.tempChooseList
			} else if (this.tabActive === 'lack') {
				rectDetail = this.typeLack
			}
			let appendInfo = JSON.parse(rectDetail[this.rectIndex].appendInfo)
			let box = appendInfo.box
			let addRectParam = {
				w: this.rectForm.w,
				h: this.rectForm.h,
				x: this.rectForm.x,
				y: this.rectForm.y
			}
			box[this.ppiIndex] = Object.assign({}, box[this.ppiIndex], addRectParam)
			appendInfo.box = box
			rectDetail[this.rectIndex].appendInfo = JSON.stringify(appendInfo)
			if (this.tabActive === 'examNo') {
				this.setTempRectExamNoInfo(rectDetail)
			} else if (this.tabActive === 'objective') {
				this.setTempRectObjective({ val: rectDetail, state: true })
			}
		},
		// 考号 新增 确认
		examNoAddRect() {
			let rectDetail = {}
			let v = null
			if (this.tabActive === 'examNo') {
				rectDetail = this.tempRectExamNoInfo
				v = this.rectVal
			} else if (this.tabActive === 'objective') {
				rectDetail = this.rectItem
			}
			let appendInfo = JSON.parse(rectDetail[this.rectIndex].appendInfo)
			let box = JSON.parse(rectDetail[this.rectIndex].appendInfo).box ?? []
			let w = 50,
				h = 34
			if (box.length > 0) {
				w = box[0].w
				h = box[0].h
			}
			const insertBox = {
				c: 1,
				r: 1,
				h: h,
				w: w,
				v: v,
				x: this.rectInfo.x,
				y: this.rectInfo.y
			}
			box.push(insertBox)
			appendInfo.box = box
			rectDetail[this.rectIndex].appendInfo = JSON.stringify(appendInfo)
			const params = {
				subjectId: this.query.subjectId,
				examId: this.query.examId,
				ppiId: rectDetail[this.rectIndex]['pkId'],
				ppiStr: JSON.stringify(rectDetail[this.rectIndex])
			}
			this.$post('Cv/refreshPpi', params).then(res => {
				if (res.code === 200) {
					this.$message({ type: 'success', message: '新增成功' })
					this.setTempFlushData({ state: true })
					this.addRectState = false
				}
			})
		},

		//微调题号位置
		changeTitlePos(val, type) {
			this.addTitleForm[type] = val
			let rectDetail = this.tempRectObjective.val
			let remarks = JSON.parse(rectDetail[this.rectIndex].remarks)
			let title = remarks.title
			if (typeof title === 'string') title = JSON.parse(title)
			title[this.ppiIndex] = Object.assign({}, title[this.ppiIndex], {
				x: +this.addTitleForm.x,
				y: +this.addTitleForm.y
			})
			remarks.title = title
			rectDetail[this.rectIndex].remarks = JSON.stringify(remarks)
			this.setTempRectObjective({ val: rectDetail, state: false })
		},

		// ------------------------------旋转操作-----------------------------
		formatList(val) {
			this.rotateState = true
			this.rotateIndex = val.rectIndex
			let info = {
				box: JSON.parse(val.rectVal.appendInfo).box,
				title: JSON.parse(val.rectVal.remarks).title
			}
			if (this.tabActive === 'examNo') {
				this.formatExamNoObj = info
			} else if (this.tabActive === 'objective') {
				this.formatObjectiveObj = info
			}
		},
		// 向下旋转
		rotateDown() {
			if (this.tabActive === 'examNo') {
				verticalRotate(this.formatExamNoObj, 0.1).then(res => this.operateExamRotate(res.box, []))
			} else if (this.tabActive === 'objective') {
				verticalRotate(this.formatObjectiveObj, 0.1).then(res => this.operateObjRotate(res.box, res.title))
			}
		},
		// 向上旋转
		rotateUp() {
			if (this.tabActive === 'examNo') {
				verticalRotate(this.formatExamNoObj, -0.1).then(res => this.operateExamRotate(res.box, []))
			} else if (this.tabActive === 'objective') {
				verticalRotate(this.formatObjectiveObj, -0.1).then(res => this.operateObjRotate(res.box, res.title))
			}
		},
		//向右旋转
		rotateRight() {
			if (this.tabActive === 'examNo') {
				horizontalRotate(this.formatExamNoObj, 0.1).then(res => this.operateExamRotate(res.box, []))
			} else if (this.tabActive === 'objective') {
				horizontalRotate(this.formatObjectiveObj, 0.1).then(res => this.operateObjRotate(res.box, res.title))
			}
		},
		//向左旋转
		rotateLeft() {
			if (this.tabActive === 'examNo') {
				horizontalRotate(this.formatExamNoObj, -0.1).then(res => this.operateExamRotate(res.box, []))
			} else if (this.tabActive === 'objective') {
				horizontalRotate(this.formatObjectiveObj, -0.1).then(res => this.operateObjRotate(res.box, res.title))
			}
		},
		// 旋转后处理数据 考号
		operateExamRotate(box) {
			let tempRectExamNo = this.tempRectExamNoInfo[this.rotateIndex]
			let appendInfo = JSON.parse(tempRectExamNo.appendInfo)
			appendInfo.box = box
			this.$set(this.tempRectExamNoInfo[this.rotateIndex], 'appendInfo', JSON.stringify(appendInfo))
			this.setTempRectExamNoInfo(this.tempRectExamNoInfo)
		},
		// 旋转后处理数据 选择题
		operateObjRotate(box, title = []) {
			let tempRectObjective = this.tempRectObjective.val[this.rotateIndex]
			let appendInfo = JSON.parse(tempRectObjective['appendInfo'])
			appendInfo.box = box
			tempRectObjective.appendInfo = JSON.stringify(appendInfo)
			if (title.length) {
				let remarks = JSON.parse(tempRectObjective['remarks'])
				remarks.title = title
				tempRectObjective.remarks = JSON.stringify(remarks)
			}
			this.tempRectObjective.val[this.rotateIndex] = tempRectObjective
			this.$set(this.tempRectObjective.val[this.rotateIndex], 'appendInfo', JSON.stringify(appendInfo))
			this.setTempRectObjective({ val: this.tempRectObjective.val, state: true })
		},
		//确定 旋转
		confirmRotate() {
			let ppiId = '',
				ppiStr = ''
			if (this.tabActive === 'examNo') {
				ppiId = this.tempRectExamNoInfo[0].pkId
				ppiStr = JSON.stringify(this.tempRectExamNoInfo[0])
			} else if (this.tabActive === 'objective') {
				ppiId = this.tempRectObjective.val[this.rotateIndex].pkId
				ppiStr = JSON.stringify(this.tempRectObjective.val[this.rotateIndex])
			}
			this.refreshPpi(ppiId, ppiStr).then(() => {
				this.$message.success('旋转成功')
				this.setTempFlushData({ state: true })
			})
			this.rotateState = false
		},
		async refreshPpi(ppiId, ppiStr) {
			const params = {
				subjectId: this.query.subjectId,
				examId: this.query.examId,
				versionId: this.tempEditImgInfo.versionId,
				ppiId,
				ppiStr
			}
			return refreshBox(this, 'Cv/refreshPpi', params)
		},

		//取消 旋转
		quitRotate() {
			this.rotateState = false
		},
		// 手动设置题号 确定
		confirmHandleSetTit() {
			// let resObjTopic = []
			// this.tempObjTopic.map(res => resObjTopic.push(...res.val))
			// resObjTopic = sortBy(resObjTopic, ele => Number(ele.smallTopic))

			let resObjTopic = sortBy(this.totalResObjTopic, ele => Number(ele.smallTopic))
			let rectInfo = this.handleSetObjVal.val
			let appendInfo = JSON.parse(rectInfo.appendInfo)
			let box = appendInfo.box
			// 手动设置题号
			let infos = setHandleCopyInit(this.initObjVal, resObjTopic, box)
			// 手动设置题号
			rectInfo.boxList = infos.box
			let remarks = JSON.parse(rectInfo.remarks)
			remarks.title = infos.title
			appendInfo.box = infos.box
			rectInfo.appendInfo = JSON.stringify(appendInfo)
			rectInfo.remarks = JSON.stringify(remarks)
			this.refreshPpi(rectInfo.pkId, JSON.stringify(rectInfo)).then(() => {
				this.$message.success('设置成功')
				this.handleSetObjVal.state = false
				this.setTempFlushData({ state: true })
			})
		},
		// 手动设置题号 取消
		quitHandleSetTit() {
			this.handleSetObjVal.state = false
		}
	}
}
</script>

<style scoped lang="less">
@import '../utils/css/mark-point.less';
.coordinate {
	position: absolute;
	z-index: 20 !important;
	top: 300px;
	left: 50%;
	transform: translateX(-50%);
}
.fixState {
	padding: 10px 30px 10px;
	border-radius: 6px;
	box-sizing: border-box;
	background: white;
	box-shadow: 0 0 15px #888888;
	cursor: move;
}
.form-wrap-title {
	width: 550px;
	height: 250px;
}
.form-wrap-exam-title {
	width: 550px;
	height: 180px;
}
.form-wrap-rect {
	width: 620px;
	height: 255px;
}
.btn-evenly {
	display: flex;
	justify-content: space-evenly;
	align-items: center;
}
.btn-end {
	display: flex;
	justify-content: flex-end;
	align-items: center;
}
.title {
	text-align: center;
	height: 50px;
	line-height: 50px;
	font-size: 18px;
}
.heightDia {
	height: 310px;
}
.miniDia {
	height: 260px;
}
</style>
